import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TKhattabatMessage } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetOneOOneMMessages = async ({
  alkhattabaUUID,
  clientUUID
}: {
  alkhattabaUUID: string;
  clientUUID: string;
}): Promise<{
  data: {
    oneOOneMMessages: TKhattabatMessage[];
    oneOOneMComments: TKhattabatMessage[];
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    oneOOneMMessages: TKhattabatMessage[];
    oneOOneMComments: TKhattabatMessage[];
  }>(`khattabat/getOneOOneMMessages`, {
    alkhattabaUUID,
    clientUUID
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: { oneOOneMMessages: [], oneOOneMComments: [] },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: { oneOOneMMessages: [], oneOOneMComments: [] },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
